var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickLightGrayButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAECEF",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 16C20.48 16 16 20.48 16 26C16 31.52 20.48 36 26 36C31.52 36 36 31.52 36 26C36 20.48 31.52 16 26 16ZM26 34C21.59 34 18 30.41 18 26C18 21.59 21.59 18 26 18C30.41 18 34 21.59 34 26C34 30.41 30.41 34 26 34ZM29.88 22.29L24 28.17L22.12 26.29C21.73 25.9 21.1 25.9 20.71 26.29C20.32 26.68 20.32 27.31 20.71 27.7L23.3 30.29C23.69 30.68 24.32 30.68 24.71 30.29L31.3 23.7C31.69 23.31 31.69 22.68 31.3 22.29C30.91 21.9 30.27 21.9 29.88 22.29Z",
    fill: "#BFC5CE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickLightGrayButtonIcon);
export default __webpack_public_path__ + "static/media/tickLightGrayButtonIcon.f50afdf73df402181af06be47600ffca.svg";
export { ForwardRef as ReactComponent };